<template>
  <input class="w-full p-2 my-2 rounded-lg bg-gray-100"
         :type="type"
         :placeholder="placeholder"
         :value="modelValue"
         @input="$emit('update:modelValue', $event.target.value);"
  >
</template>

<script>
export default {
  name: "Input",
  props: ['placeholder', 'type', 'modelValue'],
  emits: ['update:modelValue'],
}
</script>

<style scoped>

</style>